import {ueDarkTheme, ueLightTheme} from '../index';
import {twinDarkTheme, twinLightTheme} from '../twinmotion';
import {UeTheme} from '../ueTheme.types';
import useTheme from '@material-ui/core/styles/useTheme';

const useLowerThemeName = (): string => {
    const theme: UeTheme = useTheme();
    const name = theme.name || '';
    const lowerName = name.toLowerCase();
    return lowerName;
};

export const useIsLightTheme = (): boolean => {
    const lowerName = useLowerThemeName();

    if (lowerName.indexOf('light') > 1) {
        return true;
    }

    return false;
};

export const useIsDarkTheme = (): boolean => {
    const lowerName = useLowerThemeName();

    if (lowerName.indexOf('dark') > 1) {
        return true;
    }

    return false;
};

export const useIsUeTheme = (): boolean => {
    const lowerName = useLowerThemeName();

    if (lowerName.indexOf('ue') === 0) {
        return true;
    }

    return false;
};

export const useIsTwinmotionTheme = (): boolean => {
    const lowerName = useLowerThemeName();

    if (lowerName.indexOf('twin') === 0) {
        return true;
    }

    return false;
};

export const useProperLightTheme = (): UeTheme => {
    const isTwinmotion = useIsTwinmotionTheme();
    return isTwinmotion ? twinLightTheme : ueLightTheme;
};

export const useProperDarkTheme = (): UeTheme => {
    const isTwinmotion = useIsTwinmotionTheme();
    return isTwinmotion ? twinDarkTheme : ueDarkTheme;
};
